export interface FleetLayers {
  markers: boolean;
  heatmap: boolean;
}

interface Props {
  layers: FleetLayers;
  onChange: (next: FleetLayers) => void;
  heatmapAvailable: boolean;
}

export function FleetLayersToggle({
  layers,
  onChange,
  heatmapAvailable,
}: Props) {
  return (
    <div
      className="absolute top-3 right-3 z-10 rounded-md bg-surface/90 backdrop-blur border border-border p-2 flex flex-col gap-1 text-xs"
      data-testid="fleet-layers"
    >
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={layers.markers}
          onChange={(e) =>
            onChange({ ...layers, markers: e.target.checked })
          }
        />
        Unidades
      </label>
      <label
        className={`flex items-center gap-2 ${
          heatmapAvailable ? "cursor-pointer" : "opacity-50 cursor-not-allowed"
        }`}
      >
        <input
          type="checkbox"
          checked={layers.heatmap}
          disabled={!heatmapAvailable}
          onChange={(e) =>
            onChange({ ...layers, heatmap: e.target.checked })
          }
        />
        Heatmap
      </label>
    </div>
  );
}
